<template>
  <div>
    <template v-if="!showRedeemCodeModal && !showConfirmApplyCodeModal && !showLinkShopModal">
      <v-card class="Kanit pa-4">
        <div class="text-right">
          <v-btn @click="$emit('close')" icon>
            <v-icon>close</v-icon>
          </v-btn>
        </div>
        <div class="text-center pt-5">
          <div class="pb-4">{{ data.name }}</div>
          <div class="pb-4" v-if="data.photo_url">
            <template v-if="onImageLoading">
              <div class="text-center">
                <v-progress-circular
                  indeterminate
                  class="my-6"
                  color="primary"
                  size="24"
                ></v-progress-circular>
              </div>
            </template>
            <img :src="data.photo_url" @load="onImgLoad" v-show="!onImageLoading" style="width: 100%; height; auto;"/>
          </div>
          <div class="pb-4" style="font-size: 14px">{{ data.details }}</div>

          <template v-if="data.code_type && data.code_type.length > 1">
            <div style="font-size: 16px;">กรุณาเลือกใช้สิทธิ์</div>
            <template v-for="(item,i) in data.code_type">
              <v-btn
                  :key="i"
                  tile
                  dark
                  color="#000"
                  @click="onCheckCode(item,data)"
                  style="width: 100%; height: 48px;"
                  class="mt-2"
                >
                <template v-if="item == 'eShop'">
                  <div>
                    <span>ช็อปออนไลน์</span>
                  </div>
                </template>
                <template v-else>
                  <div>
                    <span>ซื้อที่ร้าน {{ item }}</span>
                  </div>
                </template>
              </v-btn>
            </template>
          </template>
          <template v-else>
            <v-btn
                tile
                dark
                color="#000"
                @click="onCheckCode(data.code_type[0],data)"
                style="width: 100%; height: 48px;"
              >
              <div>
                <span>ใช้สิทธิ์</span>
              </div>
            </v-btn>
          </template>
        </div>
      </v-card>
    </template>

    <!-- Modal Show Code -->
    <v-dialog width="350px" v-model="showRedeemCodeModal">
      <v-card class="Kanit pa-4">
        <div class="text-right">
          <v-btn @click="onCloseModal" icon>
            <v-icon>close</v-icon>
          </v-btn>
        </div>
        <div>
          <div class="text-center" style="font-size: 16px;">{{ data.name}}</div>
          <div class="text-center pt-3 pb-5" >
            <span style="font-size: 48px; font-weight: 700;">{{ newCode }}</span>
            <input type="hidden" v-model="newCode">
            <button
              type="button"
              class="pl-2"
              v-clipboard:copy="newCode"
              v-clipboard:success="onCopy"
              v-clipboard:error="onError"
              icon
            >
              <v-icon>mdi-content-copy </v-icon>
            </button>
          </div>
        </div>
        <v-btn
            tile
            dark
            color="#000"
            @click="onConfirmApplyCode"
            style="width: 100%; height: 48px;"
          >
          <div>
            <span>ใช้โค๊ดนี้</span>
          </div>
        </v-btn>
      </v-card>
    </v-dialog>

    <!-- Modal Confirm Use Code -->
    <v-dialog width="350px" v-model="showConfirmApplyCodeModal">
      <v-card class="Kanit pa-4">
        <div class="text-right">
          <v-btn @click="onCloseModal" icon>
            <v-icon>close</v-icon>
          </v-btn>
        </div>
        <div>
          <div class="text-center" style="font-size: 16px;">
            หากคุณยืนยันที่จะใช้โค๊ดนี้ <br/>กรุณากดปุ่มยืนยันด้านล่างอีกครั้ง <br/> (เมื่อกดยืนยันแล้ว โค๊ดนี้จะไม่สามารถใช้ได้อีก)
          </div>
          <div class="text-center pt-3 pb-5" >
            <span style="font-size: 48px; font-weight: 700;">{{ newCode }}</span>
            <input type="hidden" v-model="newCode">
            <button
              type="button"
              class="pl-2"
              v-clipboard:copy="newCode"
              v-clipboard:success="onCopy"
              v-clipboard:error="onError"
              icon
            >
              <v-icon>mdi-content-copy </v-icon>
            </button>
          </div>
        </div>
        <v-btn
            tile
            dark
            color="#000"
            @click="onUseCode"
            style="width: 100%; height: 48px;"
          >
          <div>
            <span>ยืนยัน</span>
          </div>
        </v-btn>
      </v-card>
    </v-dialog>

    <!-- Modal show link to website -->
    <v-dialog width="350px" v-model="showLinkShopModal">
      <v-card class="Kanit pa-4">
        <div class="text-right">
          <v-btn @click="$emit('close')" icon>
            <v-icon>close</v-icon>
          </v-btn>
        </div>
        <div class="text-center">
          <div>
            <v-avatar size="72px" color="#FFF" class="mb-3">
              <v-icon dark size="72px" color="black">
                mdi-web
              </v-icon>
            </v-avatar>
          </div>
          <div class="pb-4" style="font-size: 24px;">ใช้โค้ดได้ที่ www.lamy.co.th</div>
          <v-btn
            tile
            dark
            color="#000"
            @click="onGotoWebsite"
            style="width: 100%; height: 48px;"
          >
            <div>
              <span>เข้าสู่เว็บไซต์</span>
            </div>
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import axios from "axios";

  export default {
    props:['value'],
    data() {
      return {
        data: this.value,
        showRedeemCodeModal: false,
        showConfirmApplyCodeModal: false,
        onImageLoading: true,
        copyStatus: '',
        newCode: '',
        currentCodeType: '',
        showLinkShopModal: false,

        
      }
    },
    methods: {
      onCheckCode(codeType,item) {
        if(!item.used) {
          if(codeType == 'eShop') {
            if(item.code_eshop_used || item.code_eshop_used == null) {
              this.onGenerateCode(codeType);
            } else {
              this.newCode = item.code_eshop;
              this.currentCodeType = codeType;
              this.showRedeemCodeModal = true;
            }
          } else {
            if(item.code_store_used || item.code_store_used == null) {
              this.onGenerateCode(codeType);
            } else {
              this.newCode = item.code_store;
              this.currentCodeType = codeType;
              this.showRedeemCodeModal = true;
            }
          }
        } else {
          if(codeType == 'eShop') {
            if(item.code_eshop) {
              this.newCode = item.code_eshop;
              this.currentCodeType = codeType;
              this.showRedeemCodeModal = true;
            } else {
              this.$swal.fire({ text: 'แลกของรางวัลนี้ครบแล้ว', confirmButtonColor: '#000' }); 
            }
          } else {
            if(item.code_store) {
              this.newCode = item.code_store;
              this.currentCodeType = codeType;
              this.showRedeemCodeModal = true;
            } else {
              this.$swal.fire({ text: 'แลกของรางวัลนี้ครบแล้ว', confirmButtonColor: '#000' }); 
            }
          }
        }
      },
      onGenerateCode(codeType) { //Generate Code
        var data = { 
          member_id: this.$store.state.member.id, 
          userid: this.$store.state.userid, 
          pageid: this.$store.state.pageid, 
          member_type: this.$store.state.member.member_type,
          name: this.$store.state.member.name, // ชื่อลูกค้า
          product_id: this.data.id, 
          product_name: this.data.name, 
          sub_category_id: this.data.sub_category_id, 
          recieve_by: this.data.pickup, // สาขา, จัดส่ง
          address: '', // ส่งมาถ้า receive_by >> จัดส่ง
          code_type: codeType
        };

        // console.log(data);

        axios
        .post(this.serverUrl + "lamy/privilege/redeem", data, {
          headers: { AUTHORIZATION: "Bearer xxx xxx" },
        })
        .then(async (response) => {
          if (response.data.responsecode == 200) {
            this.showRedeemCodeModal = true;
            this.newCode = response.data.data[0].code;
            this.currentCodeType = codeType;
            this.$emit('next');
            
          } else if(response.data.responsecode == 204){
            await this.$swal.fire({ text: 'แลกไม่สำเร็จ', confirmButtonColor: '#000' }); 
            this.$emit('close');
          }else {
            await this.$swal.fire({ text: response.data.reason, confirmButtonColor: '#000' });
            this.$liff.closeWindow();
            this.$emit('close');
          }

        });
         
      },
      onConfirmApplyCode(){
        this.showConfirmApplyCodeModal = true;
        this.showRedeemCodeModal = false;
      },
      onUseCode(){ 
        var data = {
          member_id: this.$store.state.member.id,
          code: this.newCode
        }

        axios
        .post(this.serverUrl + "lamy/privilege/redeem/used-code", data, {
          headers: { AUTHORIZATION: "Bearer xxx xxx" },
        })
        .then(async (response) => {
          if (response.data.responsecode == 200) {

            var message = "แลกโค้ดของรางวัล "+this.data.name;
            // window.liff.sendMessages([
            //   {
            //     text: message,
            //     type: "text",
            //   },
            // ]);
            this.$store.dispatch("sendMessage", message); 

            if(this.currentCodeType == 'eShop') {
              this.showConfirmApplyCodeModal = false;
              this.showLinkShopModal = true;
            } else {
              this.showConfirmApplyCodeModal = false;
              this.$emit('success');
            }
          } else {
            this.$swal.fire({ text: response.data.reason, confirmButtonColor: '#000' });
            this.$liff.closeWindow();
          }
        });
        
      },
      onGotoWebsite() {
        this.$emit('success');
        window.location.href = 'https://lamy.co.th/th/';
      },
      onCloseModal() {
        this.showRedeemCodeModal = false;
        this.showConfirmApplyCodeModal = false;
        this.$emit('success');
      },
      onImgLoad () {
        this.onImageLoading = false
      },
      onCopy: function (e) {
        // this.copyStatus = "Copied code to clipboard.";
        this.$swal.fire({ text: 'Copied code to clipboard.', confirmButtonColor: '#000' });
      },
      onError: function (e) {
        this.$swal.fire({ text: 'Failed to copy code', confirmButtonColor: '#000' });
      },


    }

    
  }
</script>

<style lang="scss" scoped>

</style>